/* @flow */

export const BLOCKS_UPDATED: string = 'news@edito:BLOCKS_UPDATED';

export const updateBlocks = (blocks: Array<EditorialBlock>) => ({
  type: BLOCKS_UPDATED,
  blocks,
});



// WEBPACK FOOTER //
// ./src/modules/news/actions/edito.js